import { render, staticRenderFns } from "./ProformAdvanceModal.vue?vue&type=template&id=1a84c0b4&scoped=true"
import script from "./ProformAdvanceModal.vue?vue&type=script&lang=js"
export * from "./ProformAdvanceModal.vue?vue&type=script&lang=js"
import style0 from "./ProformAdvanceModal.vue?vue&type=style&index=0&id=1a84c0b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a84c0b4",
  null
  
)

export default component.exports